var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SideBlock w-full p-4 bg-gray-200 rounded-md"},[_c('p',{staticClass:"text-2xl text-primary font-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"text-sm pt-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }